<template>
	<section class="container mt-md-5 mt-3 mb-3 mb-md-5 item-list-compo">
		<div class="row">
			<div class="col-12 border-bottom py-3">
				<h1 class="font-weight-bold">{{title}}</h1>
				<small>{{release}}</small>
			</div>
			<div class="col-10 m-3 article" v-html="detail"></div>
		</div>
	</section>
</template>

<style>
	.article{
		font-size: 0.9em;
		line-height: inherit;
	}
	img{
		max-width: 100%;
		width: auto;
		height:auto;
	}
</style>

<script>
	export default{
		data(){
			return{
				newsId:this.$route.params.id,
				nList:[],
				title:'',
				release:'',
				detail:'',
			}
		},
		created(){
			this.getJson()
		},
		methods:{
			async getJson(){
				await this.$axios
				.get(this.$uri+'?type=news')
				.then((response) => {
					if(response.data.is_maintenance == true){
						window.location.href="/maintenance/maintenance.html"
					}else{
						this.nList = response.data.news_list
						this.setData()
					}
				})
				.catch(() => {
					window.location.href="/error/error.html"
				})
			},
			setData(){
				for(var i=0; i<this.nList.length; i++){
					if(this.nList[i].news_id == this.newsId){
						this.title = this.nList[i].news_title
						this.release = this.nList[i].news_releasedate
						this.detail = this.nList[i].news_detail
					}
				}
			},
		}
	}
</script>